import React from "react"

import {hasProperty, formatText} from '../utils/utils';

import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';


class ViewDesign extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false
        };

        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.data = {};
        this.data.Design = null;

        if (this.props.Design) {
            this.data.Design = this.props.Design; 
        }

        this.data.id = null;
        if (this.props.id) {
            this.data.id = this.props.id; 
        }
    }

    componentDidMount() {
        if (this.data.Design) {
            this.setState({"isLoaded": true});
            return;
        }
    };

    view(json) {
        if (json) {
            return(
                <PD.Table className="panel">
                    <PD.Tbody>                                

                        {hasProperty(json, 'name') &&
                            <PD.Tr>                                
                                <PD.Th>Name</PD.Th><PD.Td><PD.PdNavLink to={"/design/" + json._id}>{json.name}</PD.PdNavLink></PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json, 'description') &&
                            <PD.Tr>
                                <PD.Th>Description</PD.Th>
                                <PD.Td>
                                    <PD.MdPresent>
                                        {json.description}
                                    </PD.MdPresent>                                    
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json, 'status') &&
                            <PD.Tr>                                
                                <PD.Th>Status</PD.Th><PD.Td>{json.status}</PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json, 'Owner') &&
                            <PD.Tr>                                
                                <PD.Th>Owner</PD.Th><PD.Td>{json.Owner.username}</PD.Td>
                            </PD.Tr>
                        }

                    </PD.Tbody>
                </PD.Table>
            )
        }
    }

    render() {
        return (
            <div>
                {this.view(this.data.Design)}
            </div>
        );
    };
};

export default ViewDesign;
